// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2iWj8","info":"UpdateTermsInfo_info__2WURi"};